import PropTypes from 'prop-types'
import { useTranslation } from '@sm360/hooks'
import clsx from 'clsx'
import formatNumber from '@sm360/helpers/dist/format-number'

const PaymentOptionPrice = ({ price, priceRounding, extraClasses, paymentOptionType }) => {
    const { t } = useTranslation()

    const baseClass = 'vc-paymentOptionPrice'
    const classNames = clsx(baseClass, extraClasses)

    if (!price || !paymentOptionType) return null
    const i18nKey = paymentOptionType === 'lease' ? 'paymentOptions.leasePrice' : 'paymentOptions.financePrice'

    return (
        <div className={classNames}>
            <span className={`${baseClass}__title`}>{t(i18nKey, { price: formatNumber(price, priceRounding) })}</span>
        </div>
    )
}

PaymentOptionPrice.propTypes = {
    /** Price value */
    price: PropTypes.number,
    /** Extra classes */
    extraClasses: PropTypes.string,
    /** Rounding option for prices */
    priceRounding: PropTypes.string,
    paymentOptionType: PropTypes.oneOf(['lease', 'finance']),
}

PaymentOptionPrice.defaultProps = {
    extraClasses: '',
    price: 0,
    priceRounding: 'ROUND_UP',
    paymentOptionType: null,
}

export default PaymentOptionPrice
